import React from "react";
import { Link } from "react-router-dom";

const Hero2 = () => {
  return (
    <>
      <div class="md:px-36 px-8 md:py-28 py-5">
        <div class="flex lg:flex-row flex-col grid-cols-2 gap-10">
          <div class="flex flex-col gap-5 justify-center p-5">
            <h1 class="text-4xl md:text-5xl font-bold">Explore</h1>
            <h1 class="text-4xl md:text-5xl font-bold">the Wonders of</h1>
            <h1 class="text-4xl md:text-6xl font-bold text-[#41A4FF]">
              The World
            </h1>
            {/* <p class="mt-4">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p> */}
            <p class="mt-4">
              Discover amazing tours and travel packages tailored just for you.
              From breathtaking landscapes to cultural treasures — your
              adventure awaits with TripNest.
            </p>
            <Link to="/tours/home">
              <button className="bg-gradient-to-r from-[#4F46E5] to-[#8B5CF6] text-white px-4 py-3 rounded-lg font-medium transition duration-300 hover:brightness-110 mt-4">
                Explore Now
              </button>
            </Link>
          </div>
          {/* <div class="">
            <img
              src="https://thumbs.dreamstime.com/b/europe-travel-happy-vacation-woman-girl-tourist-having-fun-open-arms-freedom-santorini-cruise-holiday-summer-european-194078735.jpg"
              alt="heroimg"
              class="rounded-3xl h-[100%] w-full object-cover"
            />
          </div> */}
          <div className="">
            <img
              src="/europe-travel-happy-vacation-woman-girl-tourist-having-fun-open-arms-freedom-santorini-cruise-holiday-summer-european-194078735.webp"
              alt="heroimg"
              loading="lazy"
              className="rounded-3xl h-[100%] w-full object-cover"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero2;
